type LenisLike = {
  stop: () => void;
  start: () => void;
};

let lockCount = 0;
let previousBodyOverflow = "";

/**
 * Ref-counted body scroll lock shared by every overlay (dialogs, mobile
 * menu, ...). The body style and Lenis are only touched when the count
 * transitions between 0 and 1, so overlapping overlays never unlock
 * scrolling out from under each other.
 */
export function lockBodyScroll(lenis?: LenisLike | null) {
  if (lockCount === 0) {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    lenis?.stop();
  }
  lockCount += 1;
}

export function unlockBodyScroll(lenis?: LenisLike | null) {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = previousBodyOverflow;
    previousBodyOverflow = "";
    lenis?.start();
  }
}
